import { render } from "./CIS-Grid-Item.vue?vue&type=template&id=4e89d2f0"
import script from "./CIS-Grid-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Grid-Item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__